<template>
  <v-app id="app" :dark="$root.config.dark">
    <v-toolbar dense dark app :color="getColorScheme()" :class="['unselectable']">
      <v-toolbar-side-icon aria-label="menu" @click="nav = !nav" />
      <v-toolbar-title v-text="$root.config.appTitle" />
      <v-spacer />
      <v-btn aria-label="home" icon to="/" :title="$lang.home">
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <v-btn aria-label="charts" icon :to="getBpi()" :title="$lang.viewCharts">
        <v-icon>{{ $root.config.appIcon }}</v-icon>
      </v-btn>
      <v-btn aria-label="about" icon to="/about" :title="$lang.about">
        <v-icon>mdi-information-outline</v-icon>
      </v-btn>
    </v-toolbar>
    <v-navigation-drawer app v-model="nav" :class="['unselectable']">
      <app-avatar :icon-color="getColorScheme()" background-image="/static/images/app-avatar.webp" :icon="$root.config.appIcon" />
      <app-controls :dense="true" />
      <v-tabs centered grow v-model="tab" dark :slider-color="getColorScheme()">
        <v-tab>{{ $lang.byYear }}</v-tab>
        <v-tab>{{ $lang.customDateRange }}</v-tab>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-select :color="getColorScheme()" :prepend-icon="multiple ? 'mdi-calendar-multiple' : 'mdi-calendar'" solo hide-details deletable-chips v-model="range" :small-chips="multiple" :multiple="multiple" :items="years" :label="$lang.bpiDataByYear" :placeholder="$lang.bpiDataByYear" />
              <v-checkbox :color="getColorScheme()" v-model="multiple" :label="$lang.allowMultiple" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat v-if="tab === 1">
            <v-card-text>
              <v-date-picker :class="['elevation-6']" :color="getColorScheme()" :min-date="$root.config.minDate" :max-date="$root.config.today" is-expanded mode="range" is-inline :is-dark="$root.config.dark" v-model="range" />
              <v-btn aria-label="apply" @click="applyCustomDateRange()" :class="['mt-3']" block dark :title="$lang.applyCustomRange" :color="getColorScheme()">
                <v-icon :class="['mr-2']">{{ $root.config.appIcon }}</v-icon>
                <span v-html="$lang.applyCustomRange" />
              </v-btn>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-navigation-drawer>
    <v-content>
      <v-container>
        <page />
        <router-view />
        <app-controls :class="['mt-4']" :dark="$root.config.dark" />
      </v-container>
    </v-content>
    <v-footer inset :class="['py-4', 'elevation-24', 'unselectable']">
      <v-spacer />
      <span :class="['mr-3']">&copy;{{ date.getFullYear() }} <span :class="['hidden-md-and-down']" v-html="$root.config.appTitle" /></span>
    </v-footer>
    <loading-overlay />
    <error-dialog />
  </v-app>
</template>
<script>
import methods from './mixins/methods'
import moment from 'moment'

export default {
  name: 'App',
  mixins: [
    methods
  ],
  data () {
    return {
      tab: 0,
      nav: null,
      range: null,
      multiple: false,
      date: new Date()
    }
  },
  watch: {
    /**
     * Change the type of the range if custom date range has been selected
     * @watcher tab
     * @return {void}
     */
    tab () {
      switch (this.tab) {
        case 0:
          this.multiple = false
          break
        case 1:
          this.range = {
            start: new Date(moment(this.$config.today).subtract(3, 'days')),
            end: new Date(this.$config.today)
          }
          break
      }
    },
    /**
     * Change the type of the range according to the multiple or single year selection
     * @watcher multiple
     * @return {void}
     */
    multiple () {
      this.multiple ? this.range = [] : this.range = ''
    },
    /**
     * Watch the range field and change the route accordingly
     * @watcher range
     */
    range () {
      let end
      let start
      let path
      const minDate = this.$config.minDate
      const yearEnd = '-12-31'
      const yearStart = '-01-01'
      const firstYear = '2010'
      const currentPath = this.$route.fullPath
      if (typeof this.range === 'string' && this.range) {
        if (this.range === this.$lang.allTime) {
          return this.$router.push({
            path: this.getBpi()
          })
        }
        start = this.range === firstYear ? [minDate] : [this.range + yearStart]
        end = [this.range + yearEnd]
        path = this.getBpi(start, end)
        if (currentPath !== path) {
          this.$router.push({path})
        }
      } else {
        if (!this.range.length) {
          return
        }
        start = []
        end = []
        this.range.forEach(year => {
          start.push(year === firstYear ? minDate : year + yearStart)
          end.push(year + yearEnd)
        })
        path = this.getBpi(start, end)
        if (currentPath !== path) {
          this.$router.push({path})
        }
      }
    }
  },
  computed: {
    /**
     * Generate the array for the years dropdown
     * @computed years
     * @return {array}
     */
    years () {
      const config = this.$config
      const year = 'YYYY'
      const diff = moment(config.today).format(year) - moment(config.minDate).format(year)
      const years = Array(diff).fill(1).map((x, y) => '20' + x + y)
      if (!this.multiple) {
        years.unshift(this.$lang.allTime)
      }
      years.push(new Date().getFullYear().toString())
      return years
    }
  },
  methods: {
    /**
     * Apply custom date range
     * @computed applyCustomDateRange
     * @return {void}
     */
    applyCustomDateRange () {
      const range = this.range
      const bpiApiDateFormat = this.$config.bpiApiDateFormat
      const start = [moment(range.start).format(bpiApiDateFormat)]
      const end = [moment(range.end).format(bpiApiDateFormat)]
      const currentPath = this.$route.fullPath
      const path = this.getBpi(start, end)
      if (currentPath !== path) {
        this.$router.push({path})
      }
    }
  }
}
</script>
<style>
html
{
  cursor: default;
  scroll-behavior: smooth;
}

*
{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.unselectable
{
  user-select: none;
}

.pointer-events-none
{
  pointer-events: none;
}

.item-clickable
{
  cursor: pointer;
}

.vc-container
{
  border-radius: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue